import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
  timeout: 120000,
});

export const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

export const formatApiError = (e) => {
  const data = e?.response?.data;
  let detail = data?.detail;
  if (typeof detail !== "string" && !Array.isArray(detail)) {
    detail = typeof data === "string" && /<\/?[a-z][\s>]/i.test(data) ? "Server thoda busy hai — thodi der baad try karein." : e?.message;
  }
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (typeof d?.msg === "string" ? d.msg : JSON.stringify(d))).join(", ");
  return String(detail);
};

export default api;
